<template>
    <section>
        <v-card
            v-if="showForm"
            class="formCard"
            elevation="20"
        >
            <v-alert
                v-show="snackbar"
                v-model="snackbar"
                transition="scroll-x-reverse-transition"
                style="position: fixed; z-index: 2; transform: translate(-50%, -50%); left: 50%; top: 48px;"
                :color="snackColor"
                :type="snackColor"
            >
                {{ stat.message }}
            </v-alert>
            <p class="signupHeader sarabun-thin">
                HMI Admin Signup
            </p>
            <p class="signupSubHeader">
                Please fill in the details below to create your account.
            </p>
            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
                :disabled="disableForm"
                @submit.prevent="validate()"
            >
                <v-text-field
                    v-model.trim="email"
                    class="fieldDivider"
                    label="Email"
                    clearable
                    color="green accent-4"
                    :rules="emailRules"
                />
                <v-text-field
                    v-model="password"
                    class="fieldDivider"
                    label="Create Password"
                    clearable
                    color="green accent-4"
                    :rules="passwordRules.concat([v=>/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d!@#$%^&*()-_=+{};:,.<>?/\\|\[\]~]{8,}$/.test(v) || 'Must contain uppercase, lowercase and number and at least 8 characters'])"
                    :append-icon="showPass.new ? mdiEye : mdiEyeOff"
                    :type="showPass.new ? 'text' : 'password'"
                    @click:append="showPass.new = !showPass.new"
                />
                <v-text-field
                    v-model="confirmPassword"
                    class="fieldDivider"
                    label="Retype Password"
                    clearable
                    color="green accent-4"
                    :rules="confirmPasswordRules.concat(passwordConfirmationRule)"
                    :append-icon="showPass.retype ? mdiEye : mdiEyeOff"
                    :type="showPass.retype ? 'text' : 'password'"
                    @click:append="showPass.retype = !showPass.retype"
                />
                <v-btn
                    color="green accent-4 white--text"
                    class="submitBtn"
                    type="submit"
                    :disabled="!valid || stat.code === 201 && stat.timer !== 0"
                >
                    {{ stat.code === 201 ? stat.btnMessage : 'Submit' }}
                </v-btn>
            </v-form>
        </v-card>
        <v-card
            v-else
            class="formCard"
            elevation="20"
        >
            <v-alert
                v-if="success !== null"
                dense
                :type="success ? 'success' : 'error'"
                outlined
                :color=" success ? 'teal darken-4' : 'red darken-4'"
                elevation="2"
            >
                {{ successMessage }}
            </v-alert>
            <v-alert
                v-else
                type="info"
                dense
                outlined
                color="grey darken-4"
                elevation="2"
            >
                Please wait ...
            </v-alert>
        </v-card>
    </section>
</template>

<script>
import { mdiEye, mdiEyeOff } from '@mdi/js'
import { mapActions, mapGetters } from 'vuex'

export default {
    data: ()=>({
        mdiEye, mdiEyeOff,
        stat: { code: null, message: '', btnMessage: 'Resend (30)', timer: 30 },
        disableSubmitBtn: false,
        timer: 0,
        btnText: 'Submit',
        showForm: true,
        showPass: {
            new: false,
            retype: false
        },
        adminVerifySignupMsg: null,
        successMessage: '',
        valid: false,
        snackText: '',
        snackColor: 'error',
        token: null,
        snackbar: false,
        email: '',
        password: '',
        confirmTerms: '',
        confirmPassword: '',
        emailRules: [
            v => !!v || 'Email is required',
            // v => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v) || "E-mail must be valid",
            v => /^[a-zA-Z0-9]+([._%-][a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/.test(v) || 'E-mail must be valid'
        ],
        passwordRules: [v => !!v || 'Password is required'],
        confirmPasswordRules: [v => !!v || 'Retype Password is required'],
        disableForm: false,
        success: null
    }),
    computed: {
        ...mapGetters(['adminSignupData', 'adminVerifySignupData']),
        passwordConfirmationRule() {
            return () => this.password === this.confirmPassword || 'Password must match'
        }
    },
    watch: {
        adminVerifySignupData  (newVal) {
            if (newVal) {
                // console.log('adminVerifySignupData newVal: ', newVal);
                if (newVal.status === 201) {
                    this.success = true
                    this.successMessage     = 'Registration successful!'
                    const originalMessage   = this.successMessage
                    this.showForm           = false
                    let counter             = 5
                    const updateMsg = setInterval(() => {
                        this.successMessage = `${originalMessage} (${counter})`
                        this.snackText      = this.successMessage
                        counter = counter - 1
                        if (counter === 0) clearInterval(updateMsg)
                    }, 1000)
                    setTimeout(() => {
                        this.$router.push('/admin')
                    }, 6000)
                } else {
                    this.success = false
                    this.showForm = false
                    this.successMessage = newVal.state
                    let counter = 5
                    const updateMsg = setInterval(() => {
                        this.successMessage = `${newVal.state} (${counter})`
                        counter = counter - 1
                        if (counter === 0) clearInterval(updateMsg)
                    }, 1000)
                    setTimeout(() => {
                        this.$router.push('/admin')
                    }, 6000)
                }
            }
        },
        adminSignupData (newVal) {
            if (newVal && newVal.status === 201) {
                this.disableForm = true
                this.showPass.new = false
                this.showPass.retype = false
                if (this.stat.timer !== 30) {
                    this.stat.timer = 100
                    this.stat.btnMessage = 'Resend (100)'
                }
                this.stat.message = 'Verification email sent.'
                this.stat.code = newVal.status
                this.snackColor = 'success'
                this.snackbar = true
                const interval = setInterval(() => {
                    this.stat.timer -= 1
                    this.stat.btnMessage = 'Resend (' + this.stat.timer + ')'
                    if (this.stat.timer == 0) {
                        this.stat.btnMessage = 'Resend'
                        clearInterval(interval)
                    }
                }, 1000)
            } else {
                this.stat.message = newVal.state
                this.stat.code = newVal.status
                this.snackbar = true
                this.snackColor = 'error'
                this.snackText = newVal.state
            }
            setTimeout(()=>{
                this.snackbar = false
            }, 4000)
        }
    },
    async created() {
        await this.checkTkn()
    },
    methods: {
        ...mapActions(['getCsrfToken', 'adminSignup', 'adminVerifySignup']),
        async checkTkn() {
            this.token = this.$route.query.tkn
            if (this.token !== null && this.token !== undefined) {
                this.showForm = false
                await this.adminVerifySignup({ TOKEN: this.token })
            }
        },
        async validate() {
            if (this.$refs.form.validate()) {
                await this.adminSignup({ EMAIL: this.email, PASSWORD: this.password })
            }
        }
    }
}
</script>

<style scoped>
/* @import url('https://fonts.googleapis.com/css2?family=Mulish:ital,wght@0,200..1000;1,200..1000&display=swap'); */
.sarabun-thin {
    font-family: "Mulish", sans-serif;
    font-optical-sizing: auto;
    font-weight: 600;
    font-style: normal;
    color: #000;
    font-size: 39px;
}
section {
  height: 100%;
  background-image: url("./../../../assets/loginBG.webp");
  background-position: center;
  background-size: cover;
  padding-top: 20px;
}
    .formCard {
        margin: 0 auto;
        width: 417px;
        background-color: white;
        padding: 20px;
        border-radius: 5px;
    }
        .fieldDivider {
            margin-bottom: 15px;
        }
        .signupHeader {
            /* text-shadow: 1px 1px 2px black; */
            width: 100%;
            margin: 0 auto 20px auto;

            text-align: center;
        }
        .signupSubHeader {
            margin: 0 auto 10px auto;
        }
        .signupFooter {
            margin-top: 8px;
        }
        .submitBtn {
            width: 100%;
        }
</style>
